import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestBuilder } from './request-builder';
import { AbTestService } from '@client-monorepo/common/utilities';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    @Inject('APP_ENV') private environment: { [key: string]: string },
    private http: HttpClient,
  ) {}

  public call<T>(request: RequestBuilder): Observable<T> {
    let endpoint = request.endpoint;
    if (!endpoint.startsWith('/')) {
      endpoint = '/' + endpoint;
    }
    return this.http.request<T>(
      request.method,
      `${this.environment[AbTestService.callApiWithAbsoluteUrl() ? 'base_url_abs' : 'base_url']}${endpoint}`,
      {
        ...request.getOptions(),
        params: request.getParams(),
        headers: request.getHeader(),
        body: request.body,
      },
    );
  }
}
